import React from 'react';

// Operator controls for on-demand AI summarization, above a league's slate.
//
// Staff-only and rendered nowhere else. It sits on the PUBLIC league page
// deliberately (Brian's call, 2026-08-28) -- the decision "does this game
// deserve a summary" is made while looking at the slate, so the control belongs
// next to the games rather than on a separate admin route.
const btn = (enabled) => ({
  background: enabled ? 'white' : 'transparent',
  color: enabled ? 'black' : 'rgba(255,255,255,0.4)',
  border: '1px solid rgba(255,255,255,0.4)',
  borderRadius: '16px',
  padding: '5px 14px',
  fontSize: '0.78rem',
  cursor: enabled ? 'pointer' : 'not-allowed',
  transition: 'all 0.2s',
});

const Q2Toolbar = ({
  counts,
  selectedCount,
  selectionMode,
  onToggleSelectionMode,
  onRequestSelected,
  onRequestDay,
  onClearSelection,
  busy,
  message,
  isPastDay,
  policy,
}) => {
  const done = counts.done || 0;
  const queued = (counts.queued || 0) + (counts.processing || 0);
  const none = counts.none || 0;
  const failed = counts.failed || 0;
  const total = done + queued + none + failed;

  return (
    <div
      style={{
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: '8px',
        padding: '10px 14px',
        marginBottom: '14px',
        color: 'white',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        fontSize: '0.8rem',
      }}
    >
      <strong style={{ letterSpacing: '0.05em', textTransform: 'uppercase', fontSize: '0.72rem' }}>
        AI summaries
      </strong>

      {/* The league's Q2 policy, when it is not the default. An on-demand league
          leaves most of a slate unsummarized BY DESIGN, so "0/68 done" would read
          as a backlog; it counts what exists instead. */}
      {(policy === 'on_demand' || policy === 'always') && (
        <span style={{
          fontSize: '0.66rem', letterSpacing: '0.06em', textTransform: 'uppercase',
          border: '1px solid rgba(255,255,255,0.4)', borderRadius: '10px', padding: '1px 7px',
        }}>
          {policy === 'on_demand' ? 'On-demand' : 'Always-on'}
        </span>
      )}

      <span style={{ opacity: 0.85 }}>
        {policy === 'on_demand' ? `${done} summarised` : `${done}/${total} done`}
        {queued > 0 && <span style={{ color: '#FFD700' }}> · {queued} in flight</span>}
        {failed > 0 && <span style={{ color: '#FF6347' }}> · {failed} failed</span>}
      </span>

      <span style={{ flex: 1 }} />

      {/* Past days re-summarize against the last stored odds, which for a
          finished game is the closing line -- and the picks come back graded,
          because Analyzer.add_result runs against the final score. Saying so
          here is cheaper than the operator wondering. */}
      {isPastDay && (
        <span style={{ opacity: 0.6, fontStyle: 'italic' }}>
          past day — uses closing odds
        </span>
      )}

      {message && <span style={{ opacity: 0.9 }}>{message}</span>}

      <button style={btn(true)} onClick={onToggleSelectionMode} disabled={busy}>
        {selectionMode ? 'Cancel' : 'Select games'}
      </button>

      {selectionMode && (
        <>
          <button
            style={btn(selectedCount > 0 && !busy)}
            onClick={onRequestSelected}
            disabled={selectedCount === 0 || busy}
          >
            Process selected ({selectedCount})
          </button>
          <button style={btn(selectedCount > 0 && !busy)} onClick={onClearSelection} disabled={selectedCount === 0}>
            Clear
          </button>
        </>
      )}

      <button style={btn(none > 0 && !busy)} onClick={onRequestDay} disabled={none === 0 || busy}>
        Process day ({none})
      </button>
    </div>
  );
};

export default Q2Toolbar;
